import DashboardOpportunityToolbar from './DashboardOpportunityToolbar';
export default DashboardOpportunityToolbar;
